//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RecipeClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type UpdateRecipeQueryParameters = {
  recipeId: number ;
}

export type GetRecipeQueryParameters = {
  recipeId: number ;
}

export type RemoveRecipeQueryParameters = {
  recipeId: number ;
}

export type MoveRecipeRecipeQueryParameters = {
  recipeId: number ;
  targetFolderId?: number | undefined ;
}

export type CopyRecipeRecipeQueryParameters = {
  recipeId: number ;
  targetFolderId?: number | undefined ;
}

export type GetAllRecipesForExportRecipeQueryParameters = {
  folderPublicId?: string | null | undefined ;
}

export type TogglePublishedStateRecipeQueryParameters = {
  recipeId: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/recipe";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'RecipeClient',
      'create',
    ]);
}

/**
 * Creates a new recipe for the user.
 * @param dto Dto with data for creation.
 * @return Dto with recipe's data.
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.RecipeInfoDto, unknown, Types.CreateRecipeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeInfoDto, unknown, Types.CreateRecipeDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateRecipeDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function updateUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeClient',
      'update',
      recipeId as any,
    ]);
}

/**
 * Updates the recipe for the user.
 * @param recipeId Id of the recipe for update.
 * @param dto Dto with data for update.
 * @return Dto with recipe's data.
 */
export function useUpdateMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<Types.RecipeInfoDto, unknown, Types.UpdateRecipeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeInfoDto, unknown, Types.UpdateRecipeDto, TContext> {
  const key = updateMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateRecipeDto) => Client.update(recipeId, dto),
    mutationKey: key,
  });
}
  
type Update__MutationParameters = UpdateRecipeQueryParameters & {
  dto: Types.UpdateRecipeDto;
}

/**
 * Updates the recipe for the user.
 * @param recipeId Id of the recipe for update.
 * @param dto Dto with data for update.
 * @return Dto with recipe's data.
 */
export function useUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RecipeInfoDto, unknown, Update__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateRecipeQueryParameters}): UseMutationResult<Types.RecipeInfoDto, unknown, Update__MutationParameters, TContext> {
  const key = updateMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Update__MutationParameters) => Client.update(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}
  
export function getUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.RecipeDto, unknown, Types.RecipeDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RecipeDto, unknown, Types.RecipeDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(recipeId: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId,  } = params[0] as GetRecipeQueryParameters;

    return trimArrayEnd([
        'RecipeClient',
        'get',
        recipeId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.RecipeDto, TError = unknown>(dto: GetRecipeQueryParameters, options?: Omit<UseQueryOptions<Types.RecipeDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets the recipe for the user.
 * @param recipeId Id of the recipe for get.
 * @return Dto with recipe's data.
 */
export function useGetQuery<TSelectData = Types.RecipeDto, TError = unknown>(recipeId: number, options?: Omit<UseQueryOptions<Types.RecipeDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.RecipeDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RecipeDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId,  } = params[0] as GetRecipeQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RecipeDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(recipeId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.RecipeDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets the recipe for the user.
 * @param recipeId Id of the recipe for get.
 * @return Dto with recipe's data.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.RecipeDto | undefined) => Types.RecipeDto, recipeId: number) {
  queryClient.setQueryData(getQueryKey(recipeId),
    updater
  );
}

/**
 * Gets the recipe for the user.
 * @param recipeId Id of the recipe for get.
 * @return Dto with recipe's data.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RecipeDto | undefined) => Types.RecipeDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function removeUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeClient',
      'remove',
      recipeId as any,
    ]);
}

/**
 * Deletes the recipe for the user.
 * @param recipeId Id of the recipe for update.
 * @return Dto with material's data.
 */
export function useRemoveMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(recipeId),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveRecipeQueryParameters

/**
 * Deletes the recipe for the user.
 * @param recipeId Id of the recipe for update.
 * @return Dto with material's data.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveRecipeQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.recipeId ?? options?.parameters?.recipeId!),
  mutationKey: key,
});
}
  
export function moveRecipeUrl(recipeId: number, targetFolderId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/move?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (targetFolderId === null)
    throw new Error("The parameter 'targetFolderId' cannot be null.");
else if (targetFolderId !== undefined)
    url_ += "targetFolderId=" + encodeURIComponent("" + targetFolderId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function moveRecipeMutationKey(recipeId: number, targetFolderId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'RecipeClient',
      'moveRecipe',
      recipeId as any,
      targetFolderId as any,
    ]);
}

/**
 * Moves the recipe to another folder.
 * @param recipeId Id of the recipe, that should be moved.
 * @param targetFolderId (optional) Target recipe folder id.
 */
export function useMoveRecipeMutation<TContext>(recipeId: number, targetFolderId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = moveRecipeMutationKey(recipeId, targetFolderId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.moveRecipe(recipeId, targetFolderId),
    mutationKey: key,
  });
}
  
type MoveRecipe__MutationParameters = MoveRecipeRecipeQueryParameters

/**
 * Moves the recipe to another folder.
 * @param recipeId Id of the recipe, that should be moved.
 * @param targetFolderId (optional) Target recipe folder id.
 */
export function useMoveRecipeMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, MoveRecipe__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: MoveRecipeRecipeQueryParameters}): UseMutationResult<void, unknown, MoveRecipe__MutationParameters, TContext> {
  const key = moveRecipeMutationKey(options?.parameters?.recipeId!, options?.parameters?.targetFolderId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: MoveRecipe__MutationParameters) => Client.moveRecipe(data.recipeId ?? options?.parameters?.recipeId!, data.targetFolderId ?? options?.parameters?.targetFolderId!),
  mutationKey: key,
});
}
  
export function copyRecipeUrl(recipeId: number, targetFolderId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/copy?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (targetFolderId === null)
    throw new Error("The parameter 'targetFolderId' cannot be null.");
else if (targetFolderId !== undefined)
    url_ += "targetFolderId=" + encodeURIComponent("" + targetFolderId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function copyRecipeMutationKey(recipeId: number, targetFolderId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'RecipeClient',
      'copyRecipe',
      recipeId as any,
      targetFolderId as any,
    ]);
}

/**
 * Copies the recipe to selected folder.
 * @param recipeId Id of the recipe, that should be moved.
 * @param targetFolderId (optional) Target recipe folder id.
 */
export function useCopyRecipeMutation<TContext>(recipeId: number, targetFolderId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = copyRecipeMutationKey(recipeId, targetFolderId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.copyRecipe(recipeId, targetFolderId),
    mutationKey: key,
  });
}
  
type CopyRecipe__MutationParameters = CopyRecipeRecipeQueryParameters

/**
 * Copies the recipe to selected folder.
 * @param recipeId Id of the recipe, that should be moved.
 * @param targetFolderId (optional) Target recipe folder id.
 */
export function useCopyRecipeMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CopyRecipe__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CopyRecipeRecipeQueryParameters}): UseMutationResult<void, unknown, CopyRecipe__MutationParameters, TContext> {
  const key = copyRecipeMutationKey(options?.parameters?.recipeId!, options?.parameters?.targetFolderId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CopyRecipe__MutationParameters) => Client.copyRecipe(data.recipeId ?? options?.parameters?.recipeId!, data.targetFolderId ?? options?.parameters?.targetFolderId!),
  mutationKey: key,
});
}
  
export function getAllRecipesForExportUrl(folderPublicId?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/export?";
if (folderPublicId !== undefined && folderPublicId !== null)
    url_ += "folderPublicId=" + encodeURIComponent("" + folderPublicId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllRecipesForExportDefaultOptions: Omit<UseQueryOptions<Types.PrintRecipeDto[], unknown, Types.PrintRecipeDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PrintRecipeDto[], unknown, Types.PrintRecipeDto[]>, 'queryFn'>> = {
};
export function getGetAllRecipesForExportDefaultOptions() {
  return getAllRecipesForExportDefaultOptions;
};
export function setGetAllRecipesForExportDefaultOptions(options: typeof getAllRecipesForExportDefaultOptions) {
  getAllRecipesForExportDefaultOptions = options;
}

export function getAllRecipesForExportQueryKey(folderPublicId?: string | null | undefined): QueryKey;
export function getAllRecipesForExportQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { folderPublicId,  } = params[0] as GetAllRecipesForExportRecipeQueryParameters;

    return trimArrayEnd([
        'RecipeClient',
        'getAllRecipesForExport',
        folderPublicId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeClient',
        'getAllRecipesForExport',
        ...params
      ]);
  }
}
export function __getAllRecipesForExport(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAllRecipesForExport(
      context.queryKey[2] as string | null | undefined,axiosConfig    );
}

export function useGetAllRecipesForExportQuery<TSelectData = Types.PrintRecipeDto[], TError = unknown>(dto: GetAllRecipesForExportRecipeQueryParameters, options?: Omit<UseQueryOptions<Types.PrintRecipeDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns all recipes of the user for export.
 * @param folderPublicId (optional) 
 */
export function useGetAllRecipesForExportQuery<TSelectData = Types.PrintRecipeDto[], TError = unknown>(folderPublicId?: string | null | undefined, options?: Omit<UseQueryOptions<Types.PrintRecipeDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllRecipesForExportQuery<TSelectData = Types.PrintRecipeDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PrintRecipeDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let folderPublicId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ folderPublicId,  } = params[0] as GetAllRecipesForExportRecipeQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [folderPublicId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PrintRecipeDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAllRecipesForExport(context, axiosConfig) : __getAllRecipesForExport,
    queryKey: getAllRecipesForExportQueryKey(folderPublicId),
    ...getAllRecipesForExportDefaultOptions as unknown as Omit<UseQueryOptions<Types.PrintRecipeDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns all recipes of the user for export.
 * @param folderPublicId (optional) 
 */
export function setGetAllRecipesForExportData(queryClient: QueryClient, updater: (data: Types.PrintRecipeDto[] | undefined) => Types.PrintRecipeDto[], folderPublicId?: string | null | undefined) {
  queryClient.setQueryData(getAllRecipesForExportQueryKey(folderPublicId),
    updater
  );
}

/**
 * Returns all recipes of the user for export.
 * @param folderPublicId (optional) 
 */
export function setGetAllRecipesForExportDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PrintRecipeDto[] | undefined) => Types.PrintRecipeDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function togglePublishedStateUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/toggle-published";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function togglePublishedStateMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeClient',
      'togglePublishedState',
      recipeId as any,
    ]);
}

/**
 * Toggles Published.
 * @param recipeId Id of the Recipe to change.
 * @return New Published state.
 */
export function useTogglePublishedStateMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<boolean, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<boolean, unknown, void, TContext> {
  const key = togglePublishedStateMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.togglePublishedState(recipeId),
    mutationKey: key,
  });
}
  
type TogglePublishedState__MutationParameters = TogglePublishedStateRecipeQueryParameters

/**
 * Toggles Published.
 * @param recipeId Id of the Recipe to change.
 * @return New Published state.
 */
export function useTogglePublishedStateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<boolean, unknown, TogglePublishedState__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TogglePublishedStateRecipeQueryParameters}): UseMutationResult<boolean, unknown, TogglePublishedState__MutationParameters, TContext> {
  const key = togglePublishedStateMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TogglePublishedState__MutationParameters) => Client.togglePublishedState(data.recipeId ?? options?.parameters?.recipeId!),
  mutationKey: key,
});
}